import IMask from 'imask/esm/imask';
import 'imask/esm/masked/regexp';
import 'imask/esm/masked/date';
import Litepicker from 'litepicker/dist/nocss/litepicker.umd';
import SelectController from './SelectController';

export default class DateSelectController extends SelectController {
  static targets = [
    'input',
    'value',
    'container',
    'button',
  ];

  triangleIcon = '<svg class="icon" role="img"><use xlink:href="/icons.svg#dropdown-triangle"/></svg>';

  singleDaySelected = false;

  preselectedDateString = '';

  connect() {
    this.inputTarget.addEventListener('click', this.open);
    this.inputTarget.addEventListener('change', this.onInputChange);
    this.inputTarget.addEventListener('focus', this.onInputFocus);
    this.inputTarget.addEventListener('blur', this.onInputBlur);
    this.inputTarget.addEventListener('blur', this.onInputTabBlur);
    this.inputTarget.addEventListener('input', this.onInput);
    this.buttonTarget.addEventListener('click', this.toggle);
    document.addEventListener('click', this.onDocumentClick);
    this.mask = IMask(this.inputTarget, {
      mask: 'DATE{ }`{-}`{ }`DATE',
      blocks: {
        DATE: {
          mask: Date,
          blocks: {
            d: {
              mask: IMask.MaskedRange,
              placeholderChar: 'Д',
              from: 1,
              to: 31,
              maxLength: 2,
            },
            m: {
              mask: IMask.MaskedRange,
              placeholderChar: 'М',
              from: 1,
              to: 12,
              maxLength: 2,
            },
            Y: {
              mask: IMask.MaskedRange,
              placeholderChar: 'Г',
              from: 1900,
              to: 2999,
              maxLength: 4,
            },
          },
        },
      },
    });

    const lang = document.documentElement.lang || 'ru';
    this.picker = new Litepicker({
      element: this.inputTarget,
      parentEl: this.containerTarget,
      inlineMode: true,
      format: 'DD.MM.YYYY',
      buttonText: {
        previousMonth: this.triangleIcon,
        nextMonth: this.triangleIcon,
      },
      singleMode: this.element.dataset.singleMode === '' || this.element.dataset.singleMode === 'true',
      showTooltip: false,
      autoRefresh: true,
      startDate: this.inputTarget.dataset.start || null,
      endDate: this.inputTarget.dataset.end || null,
      numberOfMonths: parseInt(this.element.dataset.numberOfMonths, 10) || 1,
      lang,
    });
    this.picker.on('preselect', this.onDatePreselect);
    this.picker.on('render', this.onCalendarRender);
  }

  disconnect() {
    this.inputTarget.removeEventListener('click', this.open);
    this.inputTarget.removeEventListener('change', this.onInputChange);
    this.inputTarget.removeEventListener('focus', this.onInputFocus);
    this.inputTarget.removeEventListener('blur', this.onInputBlur);
    this.inputTarget.removeEventListener('blur', this.onInputTabBlur);
    this.inputTarget.removeEventListener('input', this.onInput);
    this.buttonTarget.removeEventListener('click', this.toggle);
    document.removeEventListener('click', this.onDocumentClick);

    if (this.mask) {
      this.mask.destroy();
    }

    if (this.picker) {
      this.picker.destroy();
    }
  }

  isElementInside = (targetElement) => {
    let element = targetElement;
    while (element !== document.documentElement) {
      if (element === this.element || !element) {
        return true;
      }

      element = element.parentElement;
    }

    return false;
  };

  onDatePreselect = (date1, date2) => {
    if (date2 && date1.getTime() !== date2.getTime()) {
      this.singleDaySelected = false;
      this.preselectedDateString = '';
      return;
    }

    this.singleDaySelected = true;

    let day = date1.getDate();
    let month = date1.getMonth() + 1;
    const year = date1.getFullYear();
    day = day < 10 ? `0${day}` : day;
    month = month < 10 ? `0${month}` : month;
    const date = `${day}.${month}.${year}`;
    this.preselectedDateString = date;
    this.inputTarget.value = date;
    this.mask.updateValue();
    const customEvent = new Event('customInput');
    this.inputTarget.dispatchEvent(customEvent);
  };

  // Correct the single day input (delete repeated date value and delimiter).
  correctSingleDayRange() {
    this.singleDaySelected = false;
    const date = this.preselectedDateString;
    this.preselectedDateString = '';
    this.picker.setDateRange(date, date);
    this.singleDaySelected = true;
    this.preselectedDateString = date;
    this.inputTarget.value = date;
    this.mask.updateValue();
  }

  onCalendarRender = (calendar) => {
    const daysContainer = calendar.querySelector('.container__days');
    if (!daysContainer) {
      return;
    }

    // Add "dots" for the days in the next month:
    while (daysContainer.children.length % 7 !== 0) {
      const cell = document.createElement('div');
      daysContainer.appendChild(cell);
    }

    if (this.singleDaySelected) {
      this.correctSingleDayRange();
    }
  };

  onInput = () => {
    this.singleDaySelected = false;
    this.preselectedDateString = '';
  };

  onInputChange = (event) => {
    if (!event.target.value.length) {
      this.picker.clearSelection();
    }
  };

  onInputTabBlur = (event) => {
    if (this.isElementInside(event.relatedTarget) && !this.opened) {
      this.open();
    }
  };
}
